import request from '@/router/axios'
import env from '@/config/env'

/**
 * 上传新增某个应用的新版本
 */
export const uploadApp = (data, params) => {
  return request({
    url: env.ferryUrl + '/appVcs/deploy',
    method: 'POST',
    timeout: 180000,
    data,
    params
  })
}
// 查询版本列表
export const fetchList = (params) => {
  return request({
    url: env.ferryUrl + '/appVcs/page',
    method: 'POST',
    data: params
  })
}
// 启用
export const enableApp = (params) => {
  return request({
    url: env.ferryUrl + '/appVcs/enable',
    method: 'GET',
    params
  })
}
// 获取正在使用版本
export const getLatest = (params) => {
  return request({
    url: env.ferryUrl + '/appVcs/latest',
    method: 'GET',
    params
  })
}
// 获取验证码
export const getVerificationCode = () => {
  return request({
    url: env.ferryUrl + '/boss-operation/getUniversalVerificationCode?bizType=2',
    method: 'GET'
  })
}
